module.exports = __webpack_public_path__ + "img/d10.296525ba.svg";